import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/kh-templates`;
export const modelName = 'khtemplate';

export default {
  ...apiCrud({ baseUri, modelName }),
};
